module.exports = __webpack_public_path__ + "media/images/design/common/images/mark_search-c6b56e7badbbae6764c6095e827fab77.gif";